export const USER_QUERIES = {
  USERS: "users:list",
  USER_DETAIL: "users:detail",
  PROFILES: "users:profiles",
} as const;
